'use client';

import useCart from '@/store/cart.store';
import CartPopUpWrapperV2 from './cart-popup-wrapper-v2';
import { useEffect, useState } from 'react';

const CartPopup = () => {
  const state = useCart((store) => store);

  const [isReloaded, setIsReloaded] = useState(false);

  // Start Of Close Popup after Reload Page
  useEffect(() => {
    if (window?.performance?.navigation?.type === 1) {
      setIsReloaded(true);
    }
  }, []);

  useEffect(() => {
    if (isReloaded && (state.cartpopup || state.openDrawer)) {
      state.closeAll();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReloaded]);

  // End Of Close Popup after Reload Page

  useEffect(() => {
    if (!state?.cartItems?.length && (state.cartpopup || state.openDrawer)) {
      state.closeAll();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.cartItems]);

  return (
    (state?.cartpopup || state?.openDrawer || !!state?.cartItems?.length) && (
      <CartPopUpWrapperV2 state={state} />
    )
  );
};

export default CartPopup;
